import React from 'react';
import { BitcoinIcon, KeyRoundIcon, LandmarkIcon } from 'lucide-react';
type MarkProps = {
  className?: string;
};

// Brand-colored acceptance marks
function VisaMark({
  className
}: MarkProps) {
  return <svg viewBox="0 0 48 16" className={className} aria-hidden="true" data-id="element-938" data-mp="rry64h3i1b5d">
      <text x="24" y="13.2" textAnchor="middle" fontFamily="Arial Black, Arial, sans-serif" fontWeight="900" fontStyle="italic" fontSize="15" letterSpacing="-0.5" fill="#1A1F71" data-id="element-939" data-mp="mtwo7zht7hvh">
        VISA
      </text>
    </svg>;
}
function MastercardMark({
  className
}: MarkProps) {
  return <svg viewBox="0 0 40 24" className={className} aria-hidden="true" data-id="element-940" data-mp="92j52mntcm0z">
      <circle cx="14" cy="12" r="10" fill="#EB001B" data-id="element-941" data-mp="447zio4jwxok" />
      <circle cx="26" cy="12" r="10" fill="#F79E1B" data-id="element-942" data-mp="3v9gcek3mia3o" />
      <path d="M20 4a10 10 0 0 1 0 16a10 10 0 0 1 0-16z" fill="#FF5F00" data-id="element-943" data-mp="3v86epw0on3xk" />
    </svg>;
}
function AmexMark({
  className
}: MarkProps) {
  return <svg viewBox="0 0 36 24" className={className} aria-hidden="true" data-id="element-944" data-mp="24ij63m3szzev">
      <rect x="0" y="0" width="36" height="24" fill="#2E77BC" data-id="element-945" data-mp="24gg4s5x7ajuu" />
      <text x="18" y="11" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="7" fill="#fff" data-id="element-946" data-mp="29aavvuf4y13y">
        AMERICAN
      </text>
      <text x="18" y="19" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="7" fill="#fff" data-id="element-947" data-mp="1uiiihnywix4v">
        EXPRESS
      </text>
    </svg>;
}
function DinersMark({
  className
}: MarkProps) {
  return <svg viewBox="0 0 24 24" className={className} aria-hidden="true" data-id="element-948" data-mp="2s8n8xr963v4t">
      <circle cx="12" cy="12" r="10.5" fill="#0079BE" data-id="element-949" data-mp="2s5r8nw9ukud7" />
      <circle cx="12" cy="12" r="6.5" fill="#fff" data-id="element-950" data-mp="2e7kil2b53yo3" />
      <line x1="12" y1="5.5" x2="12" y2="18.5" stroke="#0079BE" strokeWidth="1.5" data-id="element-951" data-mp="2i9xmdl6btmi8" />
    </svg>;
}
function JcbMark({
  className
}: MarkProps) {
  const blocks = ['#0E4C96', '#E21836', '#007B40'];
  return <svg viewBox="0 0 36 24" className={className} aria-hidden="true" data-id="element-952" data-mp="16uiugvsz5ktz">
      {['J', 'C', 'B'].map((l, i) => <g key={l} data-id="element-953" data-mp="39hzaxjkvv5ro" data-mpi={i}>
          <rect x={0.75 + i * 12} y="0.75" width="10" height="22.5" fill={blocks[i]} data-id="element-954" data-mp="39g4m3u6hqtib" />
          <text x={5.75 + i * 12} y="16" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="10" fill="#fff" data-id="element-955" data-mp="34i365i4d3ab2">
            {l}
          </text>
        </g>)}
    </svg>;
}
const marks = [{
  name: 'Visa',
  node: <VisaMark className="h-4 w-auto" data-id="element-956" data-mp="2qs9fqvd7khz8" />
}, {
  name: 'Mastercard',
  node: <MastercardMark className="h-6 w-auto" data-id="element-957" data-mp="2lqtryvjnbxd5" />
}, {
  name: 'American Express',
  node: <AmexMark className="h-6 w-auto" data-id="element-958" data-mp="2gs8siyc7xhpr" />
}, {
  name: 'Diners Club',
  node: <DinersMark className="h-6 w-auto" data-id="element-959" data-mp="2gulh3ucheqbs" />
}, {
  name: 'JCB',
  node: <JcbMark className="h-6 w-auto" data-id="element-960" data-mp="2bv8lak3mu8x2" />
}, {
  name: 'Bank Transfer',
  node: <LandmarkIcon className="h-5 w-5 text-[#3B5B7A]" strokeWidth={1.5} data-id="element-961" data-mp="f1nljqrbljn5" />
}, {
  name: 'Private Banking',
  node: <KeyRoundIcon className="h-5 w-5 text-[#9C7A3C]" strokeWidth={1.5} data-id="element-962" data-mp="a22ib454ap4m" />
}, {
  name: 'Digital Assets',
  node: <BitcoinIcon className="h-5 w-5 text-[#F7931A]" strokeWidth={1.75} data-id="element-963" data-mp="iia0rcfonlbu" />
}];
export function PaymentMarks() {
  return <ul className="mt-6 flex flex-wrap items-center gap-x-7 gap-y-5" data-id="element-964" data-mp="mj3mq09keq23">
      {marks.map(mark => <li key={mark.name} className="flex h-8 items-center" title={mark.name} data-id="element-965" data-mp="rceuq4q45cvl">
          {mark.node}
          <span className="sr-only" data-id="element-966" data-mp="w9ycvfpxm9st">{mark.name}</span>
        </li>)}
    </ul>;
}